module.exports = __webpack_public_path__ + "static/media/MHRM00N0004.66a4ff9a.svg";